module.exports = __webpack_public_path__ + "static/img/4489_phase_function_Paper_PointsHejduk_Prediction.99b6f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4489_phase_function_Paper_PointsHejduk_Prediction.png
// module id = JDIa
// module chunks = 0